export const SeriesGotDatabase = [
    {
        'id': '1',
        'name':'Season 1 (2011)', 
        'category':'tv-series', 
        'description':'Trouble is brewing in the Seven Kingdoms of Westeros. For the driven inhabitants of this visionary world, control of Westeros. The Iron Throne holds the lure of great power. But in a land where the seasons can last a lifetime, winter is coming...and beyond the Great Wall that protects them, an ancient evil has returned. In Season One, the story centers on three primary areas: the Stark and the Lannister families, whose designs on controlling the throne threaten a tenuous peace; the dragon princess Daenerys, heir to the former dynasty, who waits just over the Narrow Sea with her malevolent brother Viserys; and the Great Wall--a massive barrier of ice where a forgotten danger is stirring.',
        "src": require('./img/season-1.jpeg')
    },
    {
        'id': '2',
        'name':'Season 2 (2012)',
        'category':'tv-series',
        "description": "The cold winds of winter are rising in Westeros...war is coming...and five kings continue their savage quest for control of the all-powerful Iron Throne. With winter fast approaching, the coveted Iron Throne is occupied by the cruel Joffrey, counseled by his conniving mother Cersei and uncle Tyrion. But the Lannister hold on the Throne is under assault on many fronts. Meanwhile, a new leader is rising among the wildings outside the Great Wall, adding new perils for Jon Snow and the order of the Night's Watch.",
        "src": require('./img/season-2.jpg')
    },
    {
        'id': '3',
        'name':'Season 3 (2013)',
        'category':'tv-series',
        "description": "Duplicity and treachery...nobility and honor...conquest and triumph...and, of course, dragons. In Season 3, family and loyalty are the overarching themes as many critical storylines from the first two seasons come to a brutal head. Meanwhile, the Lannisters maintain their hold on King's Landing, though stirrings in the North threaten to alter the balance of power; Robb Stark, King of the North, faces a major calamity as he tries to build on his victories; a massive army of wildlings led by Mance Rayder march for the Wall; and Daenerys Targaryen--reunited with her dragons--attempts to raise an army in her quest for the Iron Throne.",
        "src": require('./img/season-3.jpg')
    },
    {
        'id': '4',
        'name':'Season 4 (2014)',
        'category':'tv-series',
        "description": "The War of the Five Kings is drawing to a close, but new intrigues and plots are in motion, and the surviving factions must contend with enemies not only outside their ranks, but within.",
        "src": require('./img/season-4.jpg')
    },
    {
        'id': '5',
        'name':'Season 5 (2015)',
        'category':'tv-series',
        "description": "The War of the Five Kings, once thought to be drawing to a close, is instead entering a new and more chaotic phase. Westeros is on the brink of collapse, and many are seizing what they can while the realm implodes, like a corpse making a feast for crows. In Season 5, the story centers on the surviving factions after the first three seasons, as new intrigues and plots are in motion, and the surviving factions must contend with enemies not only outside their ranks, but within.",
        "src": require('./img/season-5.jpg')
    },
    {
        'id': '6',
        'name':'Season 6 (2016)',
        'category':'tv-series',
        "description": "Following the shocking developments at the conclusion of season five, survivors from all parts of Westeros and Essos regroup to press forward, inexorably, towards their uncertain individual fates. Familiar faces will forge new alliances to bolster their strategic chances at survival, while new characters will emerge to challenge the balance of power in the east, west, north and south.",   
        "src": require('./img/season-6.jpg')
    },
    {
        'id': '7',
        'name':'Season 7 (2017)',
        'category':'tv-series',
        "description": "The long winter is here. And with it comes a convergence of armies and attitudes that have been brewing for years.",
        "src": require('./img/season-7.jpg')
    },
    {
        'id': '8',
        'name':'Season 8 (2019)',
        'category':'tv-series',
        "description": "The Great War has come, the Wall has fallen and the Night King's army of the dead marches towards Westeros. The end is here, but who will take the Iron Throne?",
        "src": require('./img/season-8.jpg')
    }

]
